import React, { useContext } from 'react';
import { Heading } from '@printdeal/ui-library';

import { useEntityTotals } from '@printdeal/checkout-frontend';
import { Money } from '../../../../Money';
import { SanitizedLineItem } from '../../../../../types/order/Order';
import OrderDetailContext from '../../contexts/OrderDetailContext';

interface LineItemOpenProps {
  lineItem: SanitizedLineItem;
}

const LineItemPrice = ({ lineItem }: LineItemOpenProps) => {
  const { order } = useContext(OrderDetailContext);

  // @ts-expect-error type mismatch
  const { lineItemsTotal } = useEntityTotals({ entity: order });
  const lineItemTotal = lineItemsTotal?.get(lineItem.id);

  if (!order) {
    return null;
  }

  return (
    <Heading variant="display" size="3" as="div">
      <Money
        value={lineItemTotal?.product?.price.totalGross.centAmount ?? 0}
        currency={lineItemTotal?.product?.price.totalGross.currencyCode}
      />
    </Heading>
  );
};

export default LineItemPrice;
